import {
  fetchVideoMetadataAndNextResources,
  fetchLyrics,
  fetchSwipeColors,
} from '@redux/common/thunks';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/browser';

import { videoPlayerResourcesInitialState } from './constants';
import { fetchSongAndNextResources } from './thunks';
import { RequestState } from './types';

const videoPlayerResourcesSlice = createSlice({
  name: 'videoPlayerResources',
  initialState: videoPlayerResourcesInitialState,
  reducers: {
    setBackgroundLoaded: (state) => {
      state.background = { state: RequestState.success, value: undefined };
    },
    setInstrumentalLoaded: (state) => {
      state.instrumental = { state: RequestState.success, value: undefined };
    },
    setVocalGuideLoaded: (state) => {
      state.vocalGuide = { state: RequestState.success, value: undefined };
    },
    setFadeDuration: (state, action: PayloadAction<number>) => {
      state.fadeDuration = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSongAndNextResources.pending, () => {
      return videoPlayerResourcesInitialState;
    });
    builder.addCase(fetchSongAndNextResources.fulfilled, (state, action) => {
      state.songDetails = { state: RequestState.success, value: action.payload };
    });
    builder.addCase(fetchSongAndNextResources.rejected, (state, action) => {
      state.songDetails = { state: RequestState.error, error: action.error };
    });

    builder.addCase(fetchVideoMetadataAndNextResources.fulfilled, (state, action) => {
      state.videoMetadata = { state: RequestState.success, value: action.payload };
    });
    builder.addCase(fetchVideoMetadataAndNextResources.rejected, (state, action) => {
      Sentry.captureMessage(JSON.stringify(action));
      if (!action.payload) {
        state.videoMetadata = { state: RequestState.error, error: action.error };
      }
    });
    builder.addCase(fetchSwipeColors.fulfilled, (state, action) => {
      state.swipeColors = { state: RequestState.success, value: action.payload };
    });
    builder.addCase(fetchLyrics.fulfilled, (state, action) => {
      state.lyrics = { state: RequestState.success, value: action.payload };
    });
  },
});

export const { setBackgroundLoaded, setInstrumentalLoaded, setVocalGuideLoaded, setFadeDuration } =
  videoPlayerResourcesSlice.actions;

export default videoPlayerResourcesSlice.reducer;
